import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { auth, db } from '../../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import '../../styles/PaidServices.css';

const stripePromise = loadStripe('pk_test_51J2BcKAq7sm3T386xKgZYhW253FisJaLfMJHmMjNeJ9ixdLmCdvf5EmdgfgmrTb5Syr1dttO0w0Jc8JHiVanbHSv00WUbNixVm');

const PaidServices = () => {
  const [selectedPlan, setSelectedPlan] = useState('');
  const [success, setSuccess] = useState(false);
  const [paymentError, setPaymentError] = useState('');
  const [isPaidUser, setIsPaidUser] = useState(false);
  const [expirationDate, setExpirationDate] = useState(null);
  const [expirationEndOfDay, setExpirationEndOfDay] = useState(null);
  const [planType, setPlanType] = useState('');

  useEffect(() => {
    const checkSubscriptionStatus = async () => {
      const user = auth.currentUser;
      if (!user) return;
  
      const payCheckRef = doc(db, 'pay_checked', user.uid);
      const payCheckSnap = await getDoc(payCheckRef);
  
      if (payCheckSnap.exists()) {
        const payCheckData = payCheckSnap.data();
  
        if (payCheckData.expiration) {
          const expiration = payCheckData.expiration.toDate();
  
          const newExpirationEndOfDay = new Date(
            expiration.getFullYear(),
            expiration.getMonth(),
            expiration.getDate() + 1, 
            0, 0, 0
          );
  
          if (new Date() < newExpirationEndOfDay) {
            setIsPaidUser(true);
            setExpirationEndOfDay(newExpirationEndOfDay);
            setPlanType(payCheckData.type || '');
          }
        } else {
          console.warn('expirationフィールドが存在しません');
        }
      } else {
        console.warn('pay_checkedコレクションに該当ドキュメントが存在しません');
      }
    };
  
    checkSubscriptionStatus();
  }, []);
  

  const handlePlanSelect = (plan) => setSelectedPlan(plan);

  const handleSubscribe = async () => {
    const stripe = await stripePromise;
    const user = auth.currentUser;

    if (!user) {
      setPaymentError('ユーザーが認証されていません。');
      return;
    }

    const priceId = selectedPlan === 'premium' 
      ? 'price_1QqvPTAq7sm3T386vnaVC5PT'  // 社会人向けプラン 980円
      : 'price_1QbbAqAq7sm3T386gcV3wL1P';  // 大学院生向けプラン 480円

    try {
      const response = await fetch('https://asia-northeast2-acematch-424cd.cloudfunctions.net/createStripeCheckoutSession', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ priceId, userId: user.uid }),
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const session = await response.json();
      const result = await stripe.redirectToCheckout({ sessionId: session.id });

      if (result.error) setPaymentError(result.error.message);
      else {
        setSuccess(true);
        setPaymentError('');
      }
    } catch (error) {
      setPaymentError('支払いに失敗しました: ' + error.message);
    }
  };

  return (
    <div className="setting-mail-container-x">
      <div className="header">
        <Link to="/settings" className="back-link-cont-x">←</Link>
        <p className="settings-title-cont">会員ステータス</p>
      </div>

      {isPaidUser ? (
        <div>      
          <h4 className="RenewalInfo-title-x">現在のステータス</h4>
        <div className="MembershipCard">
      <div className="MembershipCard-content">
        <div className="MembershipCard-icon">✔</div>
        <div className="MembershipCard-text">
          <h2 className="MembershipCard-title">有料会員</h2>
          <p className="MembershipCard-details">{planType}<br></br>次回更新日 {expirationEndOfDay ? expirationEndOfDay.toLocaleDateString() : '取得中...'} 0:00</p>
        </div>
      </div>
      <button className="MembershipCard-button">加入中</button>
    </div>
    <h4 className="RenewalInfo-title">次回更新日について</h4>
    <div className="RenewalInfo">
      <p className="RenewalInfo-text">
        ※Apple ID決済をご利用の場合、Apple IDの仕様により購読の終了日の24時間以上前に自動更新をオフにしなければ、継続決済は自動的に更新されます。
        更新日の確認方法は
        <a href="#apple-help" className="RenewalInfo-link">Pairsヘルプ「iPhoneアプリ」</a>の
        <a href="#termination-help" className="RenewalInfo-link">「購読の終了日」</a>と
        <a href="#status-help" className="RenewalInfo-link">「自動更新継続状況」</a>をご確認ください。
        更新タイミングに関するご不明点については
        <span className="RenewalInfo-highlight">Apple社</span>までお問い合わせください。
      </p>
      <p className="RenewalInfo-text">
        ※Google Play決済をご利用の場合、Google Playの仕様により次回更新日の前日に未使用残高が自動的に決済されることがございます。
        更新日の確認方法は
        <a href="#google-help" className="RenewalInfo-link">Pairsヘルプ「Androidアプリ」</a>の
        <a href="#next-billing-help" className="RenewalInfo-link">「次回更新日の確認方法」</a>をご覧ください。
        更新タイミングに関するご不明点についてはGoogle社までお問い合わせください。
      </p>
    </div>
    <Link to="/cancel-subscription" className="SubscriptionCancel">
      <span className="SubscriptionCancel-text">有料会員の解約</span>
      <span className="SubscriptionCancel-icon">➔</span>
    </Link>
    </div>
      ) : (
        <>
          <h3>有料会員になるとできること</h3>
          <img src="/images/price.png" alt="Default" />
          <h3>プランを選択してください</h3>
          <div className="plan-container">
  <div className="plan">
    <label className={`plan-card ${selectedPlan === 'basic' ? 'selected' : ''}`}>
      <input
        type="radio"
        name="plan"
        value="basic"
        checked={selectedPlan === 'basic'}
        onChange={() => handlePlanSelect('basic')}
      />
      <h3>単月プラン</h3>
      <p>月間 ¥480</p>
      <p>短期間でのご利用したい方向けのサブスクリプションプラン</p>
    </label>
    <label className={`plan-card ${selectedPlan === 'premium' ? 'selected' : ''}`}>
      <input
        type="radio"
        name="plan"
        value="premium"
        checked={selectedPlan === 'premium'}
        onChange={() => handlePlanSelect('premium')}
      />
      <h3>3ヶ月プラン</h3>
      <p>月間 ¥380 / 計 ¥1140</p>
      <p>単月プランより少しお得なサブスクリプションプラン</p>
    </label>
  </div>
</div>          <div className="note-bottom-x">
        <p>注意事項：</p>
        <ul>
          <li>・有料会員プランは毎月自動的に更新されます。</li>
          <li>・有料会員プランの解約はいつでも可能です。解約後も、プランの有効期限までサービスをご利用いただけます。</li>
          <li>・決済には「Apple pay」,「Google pay」,「クレジットカード」がご利用いただけます。</li>
          <li>・決済処理にstripeを導入しております。</li>
        </ul>
      </div>
          
          <button onClick={handleSubscribe} className="subscribe-button" disabled={!selectedPlan}>
            購入する
          </button>
          

        </>
      )}
      {success && <div className="success-message">サブスクライブが完了しました。</div>}
      {paymentError && <div className="error-message">{paymentError}</div>}
    </div>
  );
};

export default PaidServices;
